<!--
    描述：用户管理页面
    时间：2020-04-22
    Created by yefan
-->
<template>
	<div class="h100">
		<w-split class="h100"
				 v-model="splitValue">
			<div class="w-page-main left"
				 slot="left">
				<div class="w-page-header">
					<div class="left-text overflow-hidden">
						<span><b>组织架构</b></span>
					</div>
					<div class="btnGroups ml10">
					    <!--roleBtns.includes('user_organize_import') && -->
					    <el-button type="primary"
                            size="small"
                            v-if="limitId != ''"
                            @click="importOrgBtnClick()">导入组织</el-button>

						<el-button type="primary"
								   size="small"
								   @click="addClick('addDept')"
								   v-if="roleBtns.includes('user_organize_add')">新增组织</el-button>
					</div>
				</div>
				<div class="w-page-container pdb10">
					<deptTreeTable ref="deptTreeTable"
								   @deptRowClick="deptRowClick" @deleteSuccess="deptDeleteSuccess"></deptTreeTable>
				</div>
			</div>
			<div class="w-page-main right"
				 slot="right">
				<div class="w-page-header">
				    <div class="left-text overflow-hidden">
				        <el-button type="primary"
                            size="small"
                            v-if="tenantId != '' || limitId != ''"
                            @click="importBtnClick()">导入人员</el-button>
				    </div>
					<search-area ref="searchContent"
								 v-model="searchForm.sname"
								 :showMore="false"
								 placeholderName="员工姓名"
								 @on-search="onSearch"
								 @on-refresh="onRefresh"
								 @on-reset="onReset">
					</search-area>
					<div class="btnGroups ml10">
						<el-button type="primary"
								   size="small"
								   @click="addClick('addUser')"
								   v-if="roleBtns.includes('user_add')">新增人员</el-button>
					</div>
				</div>
				<div class="w-page-container">
					<usersTable ref="userTable"
								:searchObj="searchForm"></usersTable>
				</div>
			</div>
		</w-split>

        <!-- 新增、编辑等弹窗 -->
        <el-dialog :title="importUserDialog.title"
                   :visible.sync="importUserDialog.visible"
                   :width="importUserDialog.width"
                   :close-on-click-modal="false"
                   @closed="handleClose('importUser')">
            <!-- 弹窗组件 -->
            <userImportDialog v-if="importUserDialog.visible"
                ref="userImportDialog"
                :transObj="transObj"
                @handle-success="importUserSuccess"
            ></userImportDialog>
            <!-- footer 组件 -->
            <div slot="footer"
                 class="dialog-footer text-center"
                 v-if="importUserDialog.mode !== 'view'">
                <el-button size="small"
                           @click="importUserDialog.visible = false">取 消</el-button>
                <el-button type="primary"
                           size="small"
                           :loading="btnLoading"
                           @click="doSave('importUser')">保 存</el-button>
            </div>
        </el-dialog>

        <!-- 导入组织等弹窗 -->
        <el-dialog :title="importOrgDialog.title"
                   :visible.sync="importOrgDialog.visible"
                   :width="importOrgDialog.width"
                   :close-on-click-modal="false"
                   @closed="handleClose('importOrg')">
            <!-- 弹窗组件 -->
            <deptImportDialog v-if="importOrgDialog.visible"
                ref="orgImportDialog"
                @handle-success="importOrgSuccess"
            ></deptImportDialog>
            <!-- footer 组件 -->
            <div slot="footer"
                 class="dialog-footer text-center"
                 v-if="importOrgDialog.mode !== 'view'">
                <el-button size="small"
                           @click="importOrgDialog.visible = false">取 消</el-button>
                <el-button type="primary"
                           size="small"
                           :loading="btnLoading"
                           @click="doSave('importOrg')">导 入</el-button>
            </div>
        </el-dialog>
	</div>
</template>

<script>
import { getItem } from 'utils/storage'
import wSplit from '@/components/split/split'
import deptTreeTable from './components/dept_tree_table'
import usersTable from './components/users_table'
import searchArea from '../../../components/searchArea/searchArea'
import { mapState } from 'vuex'
import userImportDialog from './components/user_import_dialog'
import deptImportDialog from './components/dept_import_dialog'

export default {
	name: 'User-management',
	components: { wSplit, deptTreeTable, usersTable, searchArea, userImportDialog, deptImportDialog },
	data() {
		return {
			splitValue: 0.25,
			deptId: '',
			searchForm: {
				sname: ''
			},

			tenantId : '',  //租户id
			limitId : '',   //主体id

            btnLoading : false,
            importUserDialog : {
                title: '',
                visible: false,
                width: '550px',
                mode: 'add'
            },

            transObj : {
                deptId : '',
            },

            importOrgDialog : {
                title: '',
                visible: false,
                width: '800px',
                mode: 'add'
            },
		}
	},
	methods: {
		//新增按钮点击事件
		addClick(type) {
			type === 'addDept'
				? this.$refs.deptTreeTable.doClick('add', null)
				: this.$refs.userTable.doClick(null, 'add')
		},

		//左侧组织架构树单击行事件
		deptRowClick(row) {
			this.deptId = row.id
			this.$refs.userTable.getUsers(row.id)
		},
        deptDeleteSuccess(){
            this.deptId = ''
            this.$refs.userTable.getUsers(this.deptId)
        },
		// 确认搜索
		onSearch() {
			this.$refs.userTable.getUsers(this.deptId)
		},
		importOrgBtnClick(){
            this.importOrgDialog.title = '导入组织机构'
            this.importOrgDialog.visible = true
            this.importOrgDialog.mode = 'add'
		},
        importBtnClick(){
            if(this.deptId == '') return this.$message({'message' : '请选择组织架构信息！', type : 'warning'})
            this.transObj.deptId = this.deptId
            this.importUserDialog.title = '导入用户'
            this.importUserDialog.visible = true
            this.importUserDialog.mode = 'add'
        },
        doSave(type){
            if(type=='importUser') {
                this.$refs.userImportDialog.doSave()
            }else if(type=='importOrg') {
                this.$refs.orgImportDialog.doSave()
            }
        },
        importOrgSuccess(){
            this.importOrgDialog.visible = false
            this.$refs.deptTreeTable.getSysDept()
        },
        importUserSuccess(){
            this.importUserDialog.visible = false
            this.$refs.userTable.getUsers(this.deptId)
        },
        handleClose(type){
            if(type=='importUser') {
                this.importUserDialog.visible = false
            } else if(type=='importOrg'){
                this.importOrgDialog.visible = false
            }
        },
		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.deptId = ''
			this.searchForm.sname = ''

			// 清除树选中
			this.$refs.deptTreeTable.clearSelected()
		}
    },
    // 进入缓存页面
    activated() {
        this.splitValue = 0.25
    },
	computed: {
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	created() {
	    let tenantId = getItem('tenantId')
	    let limitId = getItem('limitId')
	    this.tenantId = tenantId !='' && tenantId != null && typeof(tenantId) != 'undefined' ? tenantId : ''
	    this.limitId = limitId !='' && limitId != null && typeof(limitId) != 'undefined' ? limitId : ''
	},
}
</script>

<style scoped lang="less">
</style>
